export const employeeCountCohorts = ['1-5', '6-10', '11-20', '21-100', '101-250', '251-1000', '1000+'];
export const titleCohorts = ['Founder/CEO', 'Finance/HR Manager', 'Employee'];
